import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 16px;
  padding: 0 20px;
`;

const StyledContent = styled.button<{ clicked: boolean }>`
  position: relative;
  color: ${({ clicked }) => (clicked ? 'var(--dk-text, black)' : 'var(--dk-text-secondary, #888D96)')};
  font-weight: ${({ clicked }) => (clicked ? '700' : '400')};
  line-height: 24px;
  transition: all 0.2s ease-in-out;
  font-size: 18px;
  white-space: nowrap;
  padding: 0 0 8px 0;
  border-bottom: ${({ clicked }) =>
    clicked ? '2px solid black' : '2px solid white'};
`;

const StyledDot = styled.div`
  position: absolute;
  right: -5px;
  top: 0;
  margin-left: 3px;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%;
`;
export { Container, StyledContent, StyledDot };
